import { RpcClient } from "../rpc-socket/rpcClient";

export type TPlannerReady = {
  url: string;
  name: string;
  format: string;
  create_time: string;
};

export const getPlannerReady = async () => {
  const token = localStorage.getItem("authToken") || "";
  return RpcClient.call("getPlannerReady", {
    token,
  }) as Promise<{
    readyList: Array<TPlannerReady>;
  }>;
};
